export const WORDPRESS_PATHS = {
  BLOG_ROUTE: '/blog',
  BLOGS: '/blog/:year?/:month?/:day?/:post?',
  GUIDES: '/sell-my-car/guides',
} as const;

export const SCROLL_OFFSET = 64;

export const VALID_YEAR_RANGE = {
  MAX: new Date().getFullYear(),
  MIN: 2017,
} as const;

export const DATE_LIMITS = {
  DAY: 31,
  MONTH: 12,
} as const;

export const TIMING = {
  PREVENT_FOUC_DELAY: 300,
  SCROLL_DELAY: 600,
  STICKY_VRM_DELAY: 500,
} as const;

export enum ContentType {
  AUTHOR = 'author',
  BLOG = 'blog',
  EMPTY = 'empty',
  ERROR = 'error',
  PAGE = 'page'
}
